<template>
  <div>
    <v-tooltip
      top
      dark
    >
      <template v-slot:activator="{ on }">
        <v-chip
          v-if="id"
          class="mp-chip"
          color="orange darken-4"
          text-color="white"
          selected
          @click="onClick"
          v-on="on"
        >
          <v-avatar>
            <v-icon>link</v-icon>
          </v-avatar>
          <span>
            ID <b>({{ id }})</b>
          </span>
          <v-icon
            class="ml-3"
            small
            @click.stop.prevent="copyId"
          >
            content_copy
          </v-icon>
        </v-chip>
        <v-chip
          v-else
          class="mp-chip"
          color="red darken-4"
          text-color="white"
        >
          ID not available
        </v-chip>
        <v-chip
          v-if="walletId"
          class="mp-chip"
          color="orange darken-4"
          text-color="white"
          selected
          @click="onClickWallet"
          v-on="on"
        >
          <v-avatar>
            <v-icon>link</v-icon>
          </v-avatar>
          <span>
            Wallet-ID <b>({{ walletId }})</b>
          </span>
          <v-icon
            class="ml-3"
            small
            @click.stop.prevent="copyWalletId"
          >
            content_copy
          </v-icon>
        </v-chip>
        <v-chip
          v-else
          class="mp-chip"
          color="red darken-4"
          text-color="white"
        >
          Wallet-ID not available
        </v-chip>
        <v-chip
          v-if="mandateId"
          class="mp-chip"
          color="orange darken-4"
          text-color="white"
          selected
          @click="onClickMandate"
          v-on="on"
        >
          <v-avatar>
            <v-icon>link</v-icon>
          </v-avatar>
          <span>
            Mandate-ID <b>({{ mandateId }})</b>
          </span>
          <v-icon
            class="ml-3"
            small
            @click.stop.prevent="copyMandateId"
          >
            content_copy
          </v-icon>
        </v-chip>
        <v-chip
          v-if="iban"
          class="mp-chip"
          color="orange darken-4"
          text-color="white"
          selected
          v-on="on"
        >
          <span>
            IBAN <b>({{ iban }})</b>
          </span>
          <v-icon
            class="ml-3"
            small
            @click.stop.prevent="copyIban"
          >
            content_copy
          </v-icon>
        </v-chip>
        <v-chip
          v-if="bic"
          class="mp-chip"
          color="orange darken-4"
          text-color="white"
          selected
          v-on="on"
        >
          <span>
            BIC <b>({{ bic }})</b>
          </span>
          <v-icon
            class="ml-3"
            small
            @click.stop.prevent="copyBic"
          >
            content_copy
          </v-icon>
        </v-chip>
      </template>
      Copy Content or visit Link
    </v-tooltip>
    <v-snackbar
      v-model="snackbar"
      bottom="bottom"
      :timeout="timeout"
      color="blue-grey"
    >
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>

export default {
  name: 'MangopayChip',
  props: {
    id: {
      type: [String, Number],
      default: null,
      required: false,
    },
    walletId: {
      type: [String, Number],
      default: null,
      required: false,
    },
    mandateId: {
      type: [String, Number],
      default: null,
      required: false,
    },
    iban: {
      type: [String, Number],
      default: null,
      required: false,
    },
    bic: {
      type: [String, Number],
      default: null,
      required: false,
    },
  },
  data() {
    return {
      snackbar: false,
      snackbarText: '',
      timeout: 2000,
    };
  },
  methods: {
    onClick() {
      window.open(`https://dashboard.mangopay.com/User/${this.id}/Details`);
    },
    onClickWallet() {
      window.open(`https://dashboard.mangopay.com/User/${this.id}/Wallets/${this.walletId}`);
    },
    onClickMandate() {
      window.open(`https://dashboard.mangopay.com/User/${this.id}/Mandates/${this.mandateId}`);
    },
    async copyId() {
      await navigator.clipboard.writeText(this.id);
      this.snackbarText = `ID "${this.id}" copied to clipboard.`;
      this.snackbar = true;
    },
    async copyWalletId() {
      await navigator.clipboard.writeText(this.walletId);
      this.snackbarText = `Wallet-ID ${this.walletId} copied to clipboard`;
      this.snackbar = true;
    },
    async copyMandateId() {
      await navigator.clipboard.writeText(this.mandateId);
      this.snackbarText = `Mandate-ID ${this.mandateId} copied to clipboard`;
      this.snackbar = true;
    },
    async copyIban() {
      await navigator.clipboard.writeText(this.iban);
      this.snackbarText = `IBAN ${this.iban} copied to clipboard`;
      this.snackbar = true;
    },
    async copyBic() {
      await navigator.clipboard.writeText(this.bic);
      this.snackbarText = `BIC ${this.bic} copied to clipboard`;
      this.snackbar = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.mp-hip {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/mangopay/MangopayChip.vue